import { z } from "zod";
import { EMAIL_TEMPLATES } from "../constants/index";
import { nonEmpty } from "./_primitives";

export const upsertNdaTemplateSchema = z.object({
  body: nonEmpty.max(50_000),
  activate: z.boolean().default(false),
});

export const upsertEmailTemplateSchema = z.object({
  key: z.enum(EMAIL_TEMPLATES),
  subject: nonEmpty.max(200),
  html: nonEmpty,
  text: z.string().optional(),
});

export type UpsertNdaTemplateInput = z.infer<typeof upsertNdaTemplateSchema>;
export type UpsertEmailTemplateInput = z.infer<typeof upsertEmailTemplateSchema>;
